var _construct = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/construct");

var _toConsumableArray = require("/vercel/workpath0/node_modules/@babel/runtime/helpers/toConsumableArray");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var React = require("react");

var _require = require("@mdx-js/react"),
    mdx = _require.mdx;

var _require2 = require("./context"),
    useMDXScope = _require2.useMDXScope;

module.exports = function MDXRenderer(_ref) {
  var scope = _ref.scope,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["scope", "children"]);

  var mdxScope = useMDXScope(scope); // Memoize the compiled component

  var End = React.useMemo(function () {
    if (!children) {
      return null;
    }

    var fullScope = _objectSpread({
      // React is here just in case the user doesn't pass them in
      // in a manual usage of the renderer
      React: React,
      mdx: mdx
    }, mdxScope);

    var keys = Object.keys(fullScope);
    var values = keys.map(function (key) {
      return fullScope[key];
    });

    var fn = _construct(Function, ["_fn"].concat(_toConsumableArray(keys), ["".concat(children)]));

    return fn.apply(void 0, [{}].concat(_toConsumableArray(values)));
  }, [children, scope]);
  return React.createElement(End, _objectSpread({}, props));
};